import { useMemo, useState } from "react";
import { INTERNAL_ROUTES } from "../../../../constants/routes";
import { getThemeLogo } from "../../../../helpers";
import { useThemeSwitch } from "../../../../theme";
import { getCurrentSelectedTenant } from "../../../../utils";

type NavLogoProps = {
  navigateTo: (route: string, openInNewTab?: boolean) => void;
  thumbLogoUrl?: string;
  addMargin?: boolean;
};

export const NavLogo = ({ navigateTo, thumbLogoUrl, addMargin }: NavLogoProps) => {
  const { appliedTheme } = useThemeSwitch();
  const themeLogo = useMemo(() => getThemeLogo(appliedTheme), [appliedTheme]);

  const [hasImageError, setHasImageError] = useState(false);

  const logoSrc = thumbLogoUrl && !hasImageError ? thumbLogoUrl : themeLogo;
  const currentTenant = getCurrentSelectedTenant();

  return (
    <img
      alt={`${currentTenant} Logo`}
      src={logoSrc}
      className="nav-logo"
      style={{
        cursor: "pointer",
        marginRight: "15px",
        height: "auto",
        width: "100px",
        maxHeight: "40px",
        objectFit: "contain",
        margin: addMargin ? "8px 0" : "0 16px 0 0",
      }}
      onClick={() => navigateTo(INTERNAL_ROUTES.Learn.route)}
      onError={() => setHasImageError(true)}
    />
  );
};
